import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDownloadStatistics,allAgentName,dowdViewType} from '../../api'
  
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'downloads',
  setup(__props) {

  const searchSelection = ref("")
  const typeStr = ref("0")
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  const allAgentNameArr=ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
    type: typeStr
  })
  
  const columns = ref([
    // { title: "id", key: "id", align: "center" },
    { title: "用户id", key: "userId", align: "center"},
    { title: "代理账号", key: "userName", align: "center" }, 
    { title: "设备码", key: "deviceId", align: "center"}, 
    { title: "ip", key: "ip", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "类型", key: "type", align: "center", customSlot: "type" },    
    { title: "平台", key: "platform", align: "center" },    
    { title: "是否结算", key: "settlement", align: "center", customSlot: "settlement" },   
    { title: "请求头", key: "userAgent", align: "center" , ellipsisTooltip: true}, 
    { title: "注册时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllDownloadStatistics = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key ,"type":search.type};
    allDownloadStatistics(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllDownloadStatistics();
  
  const change = (page: any) => {
    getAllDownloadStatistics();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllDownloadStatistics();
  }
   
  const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
       
      }
    })

  }
  allAgentNameList();


   const  dowdViewTypeArr=ref([]);
    
  const alldowdViewTypeList=()=>{
   
    dowdViewType().then((res: any) => { 
      if (res != "" && res.code == 0) {
        dowdViewTypeArr.value = res.data;
      
      } else {
        dowdViewTypeArr.value=[];
       
      }
    })

  }
  alldowdViewTypeList();



  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_space = _resolveComponent("space")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              (dowdViewTypeArr.value.length!=0)
                ? (_openBlock(), _createBlock(_component_lay_form, {
                    key: 0,
                    model: search,
                    style: {"text-align":"start"},
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_form_item, {
                        label: "类型",
                        prop: "type",
                        mode: "inline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select, {
                            modelValue: typeStr.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((typeStr).value = $event)),
                            "show-search": true,
                            multiple: false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dowdViewTypeArr.value, (dowdViewType) => {
                                return (_openBlock(), _createBlock(_component_lay_select_option, {
                                  value: dowdViewType.id,
                                  label: dowdViewType.title
                                }, null, 8, ["value", "label"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (typeStr.value==1)
                        ? (_openBlock(), _createBlock(_component_lay_form_item, {
                            key: 0,
                            label: "代理账号",
                            prop: "username",
                            mode: "inline"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lay_select, {
                                modelValue: searchSelection.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchSelection).value = $event)),
                                "show-search": true,
                                multiple: false
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAgentNameArr.value, (agent) => {
                                    return (_openBlock(), _createBlock(_component_lay_select_option, {
                                      key: agent.userId,
                                      value: agent.userId,
                                      label: agent.userName
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_lay_form_item, { mode: "inline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_button, {
                            type: "primary",
                            size: "sm",
                            onClick: searchUser
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("查询")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                type: _withCtx(({ row }) => [
                  (row.type==1)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 代理推广 ")
                        ]),
                        _: 1
                      }))
                    : (row.type==2)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 用户分享 ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 自来用户 ")
                          ]),
                          _: 1
                        }))
                ]),
                state: _withCtx(({ row }) => [
                  (row.state==0)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 正常 ")
                        ]),
                        _: 1
                      }))
                    : (row.state==1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 指纹重复 ")
                          ]),
                          _: 1
                        }))
                      : (row.state==2)
                        ? (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" ip重复 ")
                            ]),
                            _: 1
                          }))
                        : (row.state==3)
                          ? (_openBlock(), _createBlock(_component_space, { key: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 请求头部重复 ")
                              ]),
                              _: 1
                            }))
                          : (row.state==4)
                            ? (_openBlock(), _createBlock(_component_space, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 设备重复 ")
                                ]),
                                _: 1
                              }))
                            : (row.state==5)
                              ? (_openBlock(), _createBlock(_component_space, { key: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 老用户 ")
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_space, { key: 6 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 其他 ")
                                  ]),
                                  _: 1
                                }))
                ]),
                show: _withCtx(({ row }) => [
                  (row.show==0)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 不显示 ")
                        ]),
                        _: 1
                      }))
                    : (row.type==1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 显示 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                settlement: _withCtx(({ row }) => [
                  (row.state>=3 )
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }))
                    : (row.settlement==0 )
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 未结 ")
                          ]),
                          _: 1
                        }))
                      : (row.settlement==1)
                        ? (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 已结 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                ]),
                officialSettlement: _withCtx(({ row }) => [
                  (row.officialSettlement==0)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 未结 ")
                        ]),
                        _: 1
                      }))
                    : (row.officialSettlement==1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 已结 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})